import React from 'react'

const AddItemsManually2 = ({ setShowUploadModal, handleUpdateBookingObject, setAddItems }) => {

    const handleAddItemsManually = () => {
        localStorage.removeItem("visionReqId");
        localStorage.removeItem("vision_verif");
        localStorage.removeItem("VBOLog");
        localStorage.removeItem("bookingId");
        localStorage.removeItem("VBO");
        localStorage.removeItem("VBItems");
        localStorage.removeItem("VBSummary");
        localStorage.removeItem("VBOLog");
        handleUpdateBookingObject("tripStatus", "visionItems", "Click on Add Items Manually Button")
        setAddItems(true);

        handleUpdateBookingObject(null, {}, "Clicked on Add Items Manually Button, Clean all booking related local storage");

    }
    return (
        <div className="w-full max-w-[496px]  mt-[14.45px]">
            <button
                type="button"
                className="flex h-[44px] w-full items-center justify-center gap-3 rounded-[16px] bg-[#373797] font-instrument"
                onClick={() => setShowUploadModal(true)}
            >
                <img src="/images/camra.svg" alt="Upload from your device" />
                <span className="font-instrument text-[16px] text-[#F6F6F6] font-semibold leading-none">Upload from your device</span>
            </button>

            <div className="mt-7 flex items-center gap-4">
                <div className="h-px flex-1 bg-[#7876A1]" />
                <span className="font-instrument text-[12px] leading-none text-[#7876A1]">or</span>
                <div className="h-px flex-1 bg-[#7876A1]" />
            </div>

            <p className="mt-6 text-center font-instrument text-[12px] leading-none text-[#1c1f58] ">
                No photos?{' '}
                <button
                    type="button"
                    className="font-semibold underline underline-offset-2"
                    onClick={handleAddItemsManually}
                >
                    Tap here
                </button>{' '}
                to add items manually.
            </p>
        </div>
    )
}

export default AddItemsManually2